/* eslint-disable react/no-unstable-nested-components */
import { CaretRightOutlined } from '@ant-design/icons'
import { Collapse, Radio } from 'antd'
import classNames from 'classnames'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { Button } from '../../../antd/button'
import Form from '../../../components/form'
import { ICON_DEFAULT_COLOR } from '../../../constants'
import { loadNs } from '../../../i18n-config'
import { FORM_MODES } from '../../../models/form'
import { Role } from '../../../models/role'
import { CHOICES } from './contants'
import {
  BtnClass,
  ColClass,
  CollapseClass,
  ColStyled,
  DividerStyled,
  ItemStyled,
  NameLabelStyled,
  RadioClass,
  RowClass,
  RowStyled,
} from './styles'

const t = loadNs(['common', 'pages/settings/roles'])

const { Panel } = Collapse

interface RoleDetailFormContentProps {
  data: Role
  type: FORM_MODES
  isCreate: boolean
  isEdit: boolean
  fields: any
  isViewMode: boolean
}

interface IsolateButtonProps {
  text: string
  type: FORM_MODES
  disabled: boolean
}

const IsolateButton = ({ text, type, disabled }: IsolateButtonProps) => {
  const { control } = useFormContext()

  const name = useWatch({
    control,
    name: 'name',
  })
  return (
    <Button type="submit" className={classNames(BtnClass)} disabled={disabled || (type === FORM_MODES.NEW && !name)}>
      {text}
    </Button>
  )
}

export const FormContent = (props: RoleDetailFormContentProps) => {
  const { setValue } = useFormContext()
  const { data: roleData, type, fields, isCreate, isEdit, isViewMode } = props

  const genRowHeader = () => (
    <RowStyled>
      <ColStyled className={classNames(ColClass, { first: true })} span={4} />
      {CHOICES.map((choice, index) => (
        <ColStyled key={choice} className={classNames(ColClass, { isLongText: index === 3 })} span={4}>
          {choice}
        </ColStyled>
      ))}
    </RowStyled>
  )

  const onChange = (position: string, value: string) => {
    setValue(position, value)
  }

  return (
    <>
      {!isViewMode ? (
        <ItemStyled required label={t('role_name')}>
          <Form.Input defaultValue="" name="name" maxLength={100} placeholder={t('placeholder.under_100')} />
        </ItemStyled>
      ) : (
        <NameLabelStyled>
          <span className="name-title">{t('role_name')}</span>
          <span className="name-content">{roleData?.name || ''}</span>
        </NameLabelStyled>
      )}
      <DividerStyled>{t('authority')}</DividerStyled>
      <Collapse
        className={classNames(CollapseClass)}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ color: ICON_DEFAULT_COLOR }} />
        )}
        expandIconPosition="right"
      >
        {fields.map((field: any, indexCate: number) => (
          <Panel header={field.category_name_jp} key={field.category_name_jp}>
            {genRowHeader()}
            {field.permissions.map((fieldPer: any, indexPer: number) => {
              const { choices } = fieldPer
              const defaultValue = Object.keys(choices).filter(keyChoice => choices[keyChoice] === true)[0]
              return (
                <Radio.Group
                  className={classNames(RadioClass)}
                  disabled={type === FORM_MODES.VIEW}
                  key={`categories.${fieldPer.feature_id}.${fieldPer.feature_id}`}
                  defaultValue={defaultValue}
                  onChange={e => onChange(`categories[${indexCate}].permission_${indexPer}`, e.target.value)}
                >
                  <RowStyled className={classNames(RowClass, { last: indexPer === field.permissions.length - 1 })}>
                    <ColStyled className={classNames(ColClass, { first: true })} span={4}>
                      {fieldPer.feature_name_jp}
                    </ColStyled>
                    {Object.keys(choices).map((keyChoice: string) => (
                      <ColStyled span={4} key={keyChoice}>
                        {choices[keyChoice] !== null ? <Radio value={keyChoice} /> : null}
                      </ColStyled>
                    ))}
                  </RowStyled>
                </Radio.Group>
              )
            })}
          </Panel>
        ))}
      </Collapse>
      {!isViewMode && (
        <IsolateButton
          disabled={type === FORM_MODES.NEW ? !isCreate : !isEdit}
          type={type}
          text={type === FORM_MODES.NEW ? t('create') : t('save')}
        />
      )}
    </>
  )
}
